import { getSelectedCalendarsForUser as getSelectedCalendarsFromUserConfig } from 'owa-calendar-module-selected-calendars-user-config';
import { getNonNullCalendarsFromCalendarIds } from 'owa-calendar-cache';
import { CalendarEntry } from 'owa-graph-schema';

/**
 * Returns the list of selected calendars
 */
export default function getSelectedCalendarsForUser(userIdentity: string): CalendarEntry[] {
    const selectedCalendars = getSelectedCalendarsFromUserConfig(userIdentity);

    return getNonNullCalendarsFromCalendarIds(selectedCalendars);
}
